import React from 'react';
import DEFAULT_AVATAR_SVG from 'images/broken_image_person.svg';
import { twMerge } from 'tailwind-merge';
import Avatar from './Avatar';
import Icon from './Icon';

interface Props {
    className?: string;
    src?: string;
    initials?: string;
}

const AvatarPic = ({ src, initials, className }: Props) => {
    if (initials)
        return (
            <div className="flex size-9 items-center justify-center rounded-full bg-gray-300 font-bold text-black">
                {initials}
            </div>
        );

    return (
        <div>
            {DEFAULT_AVATAR_SVG ? (
                <Avatar
                    className={twMerge(
                        'size-9 rounded-full bg-gray-200',
                        className,
                    )}
                >
                    <Icon
                        iconKey={'account'}
                        className="text-gray-400"
                        size="1rem"
                    />
                </Avatar>
            ) : (
                <img
                    className="size-9 rounded-full bg-gray-200"
                    src={src}
                    alt=""
                    onError={(e) => {
                        (e.target as HTMLImageElement).src = DEFAULT_AVATAR_SVG;
                    }}
                />
            )}
        </div>
    );
};

export default AvatarPic;
